import { Module } from 'vuex';

import { RootState } from '@/types/store';
import { actions } from './actions';
import { state } from './states'
import { mutations } from './mutations'
import { UserState } from '@/types/store/user';

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};
